import { useUserSettings } from '../../../utils/use-user-settings';
import { isFeatureEnabled } from '../../../utils/feature-flags';
import SignatureTemplateDrawerDetailsOld from './signature-template-drawer-details-old';
import SignatureTemplateDrawerDetails from './signature-template-drawer-details';

export default function SignatureTemplateDrawerDetailsPage() {
  const { features } = useUserSettings();
  const isSignatureTemplateUiUpdateEnabled = isFeatureEnabled(
    'uiEnhancementPhase2',
    features
  );
  return isSignatureTemplateUiUpdateEnabled ? (
    <SignatureTemplateDrawerDetails />
  ) : (
    <SignatureTemplateDrawerDetailsOld />
  );
}
